import { render, staticRenderFns } from "./onOff.vue?vue&type=template&id=6956dfac"
import script from "./onOff.vue?vue&type=script&lang=js"
export * from "./onOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports